import { SquareMeterAreaContainer } from '../../containers/advancedFilters/SquareMeterAreaContainer';
import { IFilter } from '../../types/advancedFilters';

export const squareMeterArea: IFilter = {
  component: SquareMeterAreaContainer,
};
